import { PERSIST_REHYDRATE } from '@redux-offline/redux-offline/lib/constants'
import { getIsLoggedIn } from '@tellonym/core/app/selectors'
import { events } from '@tellonym/core/events'
import {
  LOGOUT_SUCCESS,
  REMOVE_ACCOUNT_SUCCESS,
} from '@tellonym/core/profile/types'
import { AUTHENTICATION_COMPLETED } from '@tellonym/core/user/types'
import { put, select, take } from 'redux-saga/effects'
import { _ } from '../common'

const load = function* load() {
  try {
    /**
     * App is considered loaded when persisted data is loaded into state.
     */
    yield take(PERSIST_REHYDRATE)
    const isLoggedIn = yield select(getIsLoggedIn)
    yield put(events.load({ isLoggedIn }))
  } catch (e) {
    _.capture(e)
  }
}

const ready = function* ready() {
  try {
    /**
     * App is considered ready when app is mounted, rehydrated and
     * the navigation ref is available.
     */
    yield events.ensure([events.LOAD, events.MOUNT])
    yield put(events.ready())
  } catch (e) {
    _.capture(e)
  }
}

const auth = function* auth() {
  try {
    while (true) {
      yield take([events.READY, events.UNAUTH])

      const isLoggedIn = yield select(getIsLoggedIn)
      const isDelayed = !isLoggedIn

      if (!isLoggedIn) {
        yield take(AUTHENTICATION_COMPLETED)
      }

      yield put(events.auth({ isDelayed }))
    }
  } catch (e) {
    _.capture(e)
  }
}

const unauth = function* unauth() {
  try {
    while (true) {
      yield take([LOGOUT_SUCCESS, REMOVE_ACCOUNT_SUCCESS])
      yield put(events.unauth({}))
    }
  } catch (e) {
    _.capture(e)
  }
}

/**
 * This object maps event types to their respective event factories.
 * A factory dispatches one or multiple event actions based on certain conditions.
 */
export const eventFactory = {
  [events.LOAD]: [load],
  [events.READY]: [ready],
  [events.AUTH]: [auth],
  [events.UNAUTH]: [unauth],
}
